import { render, staticRenderFns } from "./ModalUsages.vue?vue&type=template&id=67cad3c2&"
import script from "./ModalUsages.vue?vue&type=script&lang=js&"
export * from "./ModalUsages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports